import { Suspense } from "react"
import { useSelector } from "react-redux"
import { useIdleTimer } from "react-idle-timer"
import { Box, CircularProgress, CssBaseline, ThemeProvider } from "@mui/material"

import theme from "./utils/Theme"
import AppRoutes from "./routes/Routes"
import useLogout from "./hooks/useLogout"
import { getStorageItem } from "./utils/helperFunctions"
import { useHeapAnalysis } from "./hooks/useHeapAnalytics"
import { useGTM } from "./hooks/useGTM"
import "./utils/exitIntentTest"

const Spinner = () => {
  return (
    <Box className=" flex flex-col w-screen h-screen justify-center items-center ">
      <CircularProgress color="secondary" />
    </Box>
  )
}

function App() {
  useGTM()
  useHeapAnalysis()
  const isLoggedIn = useSelector((state) => state?.userAuth?.isLoggedIn)
  const logoutUser = useLogout()

  const onIdle = () => {
    const isPayment = getStorageItem("isPayment")
    if (isLoggedIn && !isPayment) {
      logoutUser()
    }
  }

  useIdleTimer({
    timeout: 5 * 60 * 1000,
    onIdle: onIdle,
    debounce: 0,
  })

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={<Spinner />}>
        <AppRoutes />
      </Suspense>
    </ThemeProvider>
  )
}

export default App
